var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2273_7537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2679 10.8428C7.2869 10.8901 7.31992 10.9305 7.36254 10.9586C7.40516 10.9866 7.45533 11.0009 7.50632 10.9996C7.55732 10.9983 7.60669 10.9814 7.64782 10.9512C7.68894 10.9211 7.71986 10.879 7.7364 10.8308L10.9864 1.33078C11.0024 1.28648 11.0055 1.23854 10.9952 1.19256C10.985 1.14659 10.9618 1.10448 10.9285 1.07117C10.8952 1.03786 10.8531 1.01473 10.8071 1.00448C10.7612 0.994228 10.7132 0.997282 10.6689 1.01328L1.1689 4.26328C1.12065 4.27983 1.07862 4.31074 1.04844 4.35187C1.01826 4.393 1.00139 4.44237 1.00008 4.49336C0.998776 4.54436 1.0131 4.59453 1.04113 4.63715C1.06916 4.67977 1.10956 4.71279 1.1569 4.73178L5.1219 6.32178C5.24725 6.37197 5.36113 6.44701 5.45669 6.5424C5.55224 6.63778 5.62749 6.75153 5.6779 6.87678L7.2679 10.8428Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.927 1.07373L5.45703 6.54323",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2273_7537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.2596e5677e52f1ff24ddafc7345e6a3a.svg";
export { ForwardRef as ReactComponent };